import { arWebArUrl } from './features'

// AR宝探し (#1154) — WebAR への遷移ヘルパ。
// トークンは URL フラグメントで渡す (サーバログ/Referer に漏れない)。
// 復帰先 (r) は本体の /stamp-rally/ar/return。WebAR はフラグメントを
// URLSearchParams として解釈する: #t=<token>&r=<returnUrl>&spot=<spotId>

export const AR_EVENT_KEY = 'yokoso.arEvent.v1'

/**
 * 「あつめたキャラ」を AR で呼び出す (召喚) ための URL。
 *
 * **起動トークンは要らない。** 召喚はスタンプにも景品にも関係しないので、渡すのは
 * スポットの ID だけ (`#summon=<スポットID>&r=<戻り先>`)。家でも、イベントが終わった
 * 後でも開ける。
 *
 * **キャラの情報 (名前・絵の URL) はリンクに載せない。** 載せると、細工したリンクで
 * 外部の絵と文字を YOKOSO PAY の画面に出せてしまう。何を出すかは WebAR がサーバに聞く
 * (`GET /stamp/ar/character/{id}`)。
 */
export function summonUrl(spotId: string, returnUrl: string, baseUrl = arWebArUrl()): string {
  const params = new URLSearchParams({ summon: spotId, r: returnUrl })
  return `${baseUrl}#${params.toString()}`
}

export function gotoSummon(spotId: string): void {
  window.location.href = summonUrl(spotId, window.location.href)
}

export function rememberArEvent(eventId: string): void {
  try {
    sessionStorage.setItem(AR_EVENT_KEY, eventId)
  } catch {
    // sessionStorage 不可でも WebAR 遷移自体は続行 (復帰演出が出ないだけ)
  }
}

export function readArEvent(): string | null {
  try {
    return sessionStorage.getItem(AR_EVENT_KEY)
  } catch {
    return null
  }
}

export function gotoWebAr(token: string, eventId: string, spotId?: string, baseUrl?: string): void {
  rememberArEvent(eventId)
  const params = new URLSearchParams({ t: token })
  params.set('r', `${window.location.origin}/stamp-rally/ar/return`)
  if (spotId) params.set('spot', spotId)
  // baseUrl = イベント設定の activityUrl (#1159)。未設定は AR 既定 (VITE_AR_WEBAR_URL)
  window.location.href = `${baseUrl || arWebArUrl()}#${params.toString()}`
}
